<template>
  <NuxtLayout name="markup" background-class="bg-surface-tertiary">
    <MarkupGenerator :page-data="markupData || undefined" :is-page="true" />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { general_setPageTheme } from '~/utils/general/pageThemeClassFromMarkup';
import { ASYNC_KEY_PREOWNED_LISTING } from '~/models/AsyncDataKeys.model';

const config = useRuntimeConfig();
const route = useRoute();
definePageMeta({
  layout: false,
});

const notificationStore = useNotificationStore();
notificationStore.reset();

const { $api } = useNuxtApp();
const { data: markupData, error } = await useAsyncData(
  ASYNC_KEY_PREOWNED_LISTING,
  async () => {
    return await $api.categoryModule.getCategory(9, true);
  },
  {
    transform: cache_addFetchedAtTransform,
    getCachedData: cache_getCachedDataFromServer,
  },
);

if (error.value) {
  notificationStore.setStandardErrorNotification();
}

const canonicalUrl = `${config.public.apiBaseUrl.replace(/\/$/, '')}${route.fullPath.split('?')[0]}`;

filters_initializeFiltersIfListComponentExists(markupData.value, true);
general_setPageTheme(markupData.value?.PageContent);

const seoInput = {
  seoData: {
    title: markupData?.value?.MetaTitle,
    description: markupData?.value?.MetaDescription,
    siteName: 'Halebop',
    keywords: markupData?.value?.MetaKeywords,
    canonicalUrl,
  },
  fallBackSeoData: {
    title: 'Köpa Begagnade Mobiler |  iPhone - Samsung - Halebop | Halebop.se',
    description:
      'Upptäck vårt sortiment av begagnade mobiler  på Halebop. Välj mellan iPhone, Samsung, Sony, Google. Köp prisvärda begagnade mobiltelefoner med kvalitet och förtroende. Utforska nu!',
    siteName: 'Halebop',
    keywords: '',
    canonicalUrl,
  },
};
useCustomSeoMeta(seoInput);
</script>

<style scoped></style>
